export default __webpack_public_path__ + "static/media/memories.e4befd0c.jpg";